<template>
  <div>
    <div class="page-head">
      <div>
        <h2>评价审核</h2>
        <p>审核用户评价，控制是否在小程序中展示。</p>
      </div>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="昵称/对象/评价内容" clearable /></el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="filters.audit_status" placeholder="全部" clearable>
            <el-option label="待审核" value="pending" />
            <el-option label="已通过" value="approved" />
            <el-option label="已拒绝" value="rejected" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="user_nickname" label="真实用户" width="140"><template slot-scope="{ row }">{{ row.user_nickname || row.name || '-' }}</template></el-table-column>
        <el-table-column prop="order_no" label="关联订单" width="190"><template slot-scope="{ row }">{{ row.order_no || '历史评价（无订单）' }}</template></el-table-column>
        <el-table-column prop="target_name" label="目标产品" min-width="170" />
        <el-table-column prop="rating" label="评分" width="90" />
        <el-table-column prop="content" label="评价内容" min-width="260" show-overflow-tooltip />
        <el-table-column prop="audit_status" label="审核状态" width="110"><template slot-scope="{ row }"><status-tag :value="row.audit_status" /></template></el-table-column>
        <el-table-column prop="display_status" label="展示状态" width="110"><template slot-scope="{ row }"><status-tag :value="row.display_status" /></template></el-table-column>
        <el-table-column label="操作" width="230" fixed="right">
          <template slot-scope="{ row }">
            <audit-button @audit="audit(row, $event)" />
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </paged-table>
    </el-card>

    <el-dialog title="编辑评价" :visible.sync="drawerVisible" width="560px" destroy-on-close>
      <el-form class="drawer-form" :model="form" label-width="120px">
        <el-form-item label="真实用户"><el-input :value="form.user_nickname || form.name" disabled /></el-form-item>
        <el-form-item label="关联订单"><el-input :value="form.order_no ? `${form.order_no} / ${form.order_name || ''}` : '历史评价（无可靠订单关联）'" disabled /></el-form-item>
        <el-form-item label="目标产品"><el-input v-model="form.target_name" disabled /></el-form-item>
        <el-form-item label="评分"><el-input :value="form.rating" disabled /></el-form-item>
        <el-form-item label="评价内容"><el-input v-model="form.content" type="textarea" :rows="5" disabled /></el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="form.audit_status">
            <el-option label="待审核" value="pending" />
            <el-option label="已通过" value="approved" />
            <el-option label="已拒绝" value="rejected" />
          </el-select>
        </el-form-item>
        <el-form-item label="展示状态">
          <el-select v-model="form.display_status">
            <el-option label="展示" value="visible" />
            <el-option label="隐藏" value="hidden" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存评价</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AuditButton from "../components/AuditButton.vue";
import PagedTable from "../components/PagedTable.vue";
import StatusTag from "../components/StatusTag.vue";
import { listResource, updateResource } from "../api/resources";

export default {
  name: "ReviewsManage",
  components: { AuditButton, PagedTable, StatusTag },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", audit_status: "" },
      form: {}
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource("reviews", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", audit_status: "" };
      this.page = 1;
      this.fetchList();
    },
    targetTypeText(value) {
      const map = {
        route: "线路",
        service: "服务",
        culture: "文化体验",
        hotel: "酒店",
        food: "美食",
        scenic: "景点"
      };
      return map[value] || value || "-";
    },
    openEdit(row) {
      this.form = { ...row, rating: Number(row.rating || 5) };
      this.drawerVisible = true;
    },
    async save() {
      this.saving = true;
      try {
        await updateResource("reviews", this.form.id, this.form);
        this.$message.success("评价已保存");
        this.drawerVisible = false;
        this.fetchList();
      } finally {
        this.saving = false;
      }
    },
    async audit(row, auditStatus) {
      const displayStatus = auditStatus === "approved" ? "visible" : "hidden";
      await updateResource("reviews", row.id, { ...row, audit_status: auditStatus, display_status: displayStatus });
      this.$message.success("评价审核状态已更新");
      this.fetchList();
    }
  }
};
</script>
